import { gql } from '@apollo/client'
import CantinaTemplate from 'components/templates/CantinaTemplate/CantinaTemplate'
import { initializeApollo, queryPagination } from 'gql/client'
import { CANTINA, ALLCANTINEPATHS } from 'utils/queries'
import { NextWrapper } from 'data-fetching-wrapper'

function Detail({ cantina, pagina }) {
  return <CantinaTemplate cantina={cantina} pagina={pagina} />
}

export const getStaticPaths = NextWrapper.getStaticPaths(async ({ locales }) => {
  let paths = []
  const maxPathsNumber = 10
  for (const locale of locales) {
    let numberAdded = 0
    const client = initializeApollo(null, null, null, locale)
    let cantine = await queryPagination(client, 'cantine', ALLCANTINEPATHS)
    cantine.forEach((item) => {
      if (numberAdded < maxPathsNumber) {
        paths.push({ params: { slug: item.slug }, locale: locale })
        numberAdded += 1
      }
    })
  }

  return {
    paths,
    fallback: 'blocking',
  }
}, '/le-cantine/[slug]')

export const getStaticProps = NextWrapper.getStaticProps(async ({ params: { slug }, locale }) => {
  const client = initializeApollo(null, null, null, locale)

  const {
    data: { cantina },
  } = await client.query({
    query: gql`
      ${CANTINA.replace('__slug__', slug).replace('__numeroProdotti__', '(first: 4)')}
    `,
  })
  if (!cantina) {
    return {
      notFound: true,
    }
  }

  return {
    props: { cantina, pagina: cantina.pagina, key: cantina.pk },
    revalidate: 60 * 10,
  }
}, '/le-cantine/[slug]')

export default Detail
